
import {defineComponent, computed, reactive, onBeforeUnmount} from 'vue'
import { useRoute } from 'vue-router'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import { UserService } from '../../services/user.service'
import { BridgeService } from '../../services/bridge.service'
import { UserInfoService } from './user-info.service'
import { login_type_info, ConfigService, product_id_info, logoInfo } from '@/services/config.service'

import UserInfoDetail from './_components/user-info-detail.vue'
import {InterestsService} from '@/views/interests/interests.service';
import { CommonService } from '@/services/common.service';
import {TabService} from '@/views/home/_components/tab.service';
import { CookieService } from '@/services/cookie.service'

/** 用户信息 */
export default defineComponent({
  name: 'UserInfo',
  components: { UserInfoDetail },
  props: {
    fixedHeight: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const route = useRoute()
    const injector = useReflectiveInjector()
    const service = injector.get(UserInfoService)
    const user = injector.get(UserService)
    const bridge = injector.get(BridgeService)
    const config = injector.get(ConfigService as Type<ConfigService>)
    const cookie = injector.get(CookieService)
    const common = injector.get(CommonService)
    const interest = injector.get(InterestsService)
    const tab = injector.get(TabService)
  
    const viewModel = reactive({
      renewStatus: false, /** 续费按钮点击状态 */
      detailVisible: false, /** 控制详情显示 */
      isVip: user.isVip,
      normalVIP: user.normalVIP,
      isDiamondVIP: user.isDiamondVIP,
      isSuperKeniuVip: user.isSuperKeniuVip,
      avatar: user.avatar,
      nickname: user.nickname,
      isLogin: user.isLogin,
      isContinuous: user.isContinuous,
      loignType: user.loignType,
      title: config.getTitle,
      memberDateText: user.memberDateText(),
      memberInterestDesc: config.getMemberInterestDesc,
      isSingleNormalMember: user.isSingleNormalMember,
      isSingleDiamondMember: user.isSingleDiamondMember,
      isSingleMember: user.isSingleMember,
      isKeniuSuperNormalMember: user.isKeniuSuperNormalMember,
      isKeniuSuperDiamondMember: user.isKeniuSuperDiamondMember,
      isKeniuSuperMember: user.isKeniuSuperMember,
      singleNormalMemberInfo: user.singleNormalMemberInfo,
      singleDiamondMemberInfo: user.singleDiamondMemberInfo,
      keniuSuperNormalMemberInfo: user.keniuSuperNormalMemberInfo,
      keniuSuperDiamondMemberInfo: user.keniuSuperDiamondMemberInfo,
      singleMemberInfo: user.singleMemberInfo,
      keniuSuperMemberInfo: user.keniuSuperMemberInfo,
      productId: cookie.productId,
      superMemberInterestList: [
        {
          pid: '102',
          img: logoInfo[product_id_info.couputerHelper],
          label: '可牛电脑助手会员',
          num: 0
        },
        {
          pid: '103',
          img: logoInfo[product_id_info.pdf],
          label: '可牛PDF会员',
          num: 0
        },
        {
          pid: '100',
          img: logoInfo[product_id_info.kantu],
          label: '可牛看图会员',
          num: 0
        },
        {
          pid: '105',
          img: logoInfo[product_id_info.video],
          label: '可牛视频转换器会员',
          num: 0
        },
      ] /** 超级会员权益 */
    })

    /** 更新各个产品特权数量 */
    const sub = interest.onInterestSizeChanged.subscribe(res => {
      viewModel.superMemberInterestList.forEach(p => {
        (res || []).forEach(c => {
          if (p.pid === c.app_id) {
            p.num = c.interest_list.length
          }
        })
      })
    })

    onBeforeUnmount(() => {
      sub.unsubscribe()
    })

    /** 订阅用户信息变化 */
    user.onUserInfoChanged.subscribe(() => {
      const assignmentField = [
        'isVip',
        'normalVIP',
        'isDiamondVIP',
        'isSuperKeniuVip',
        'avatar',
        'isLogin',
        'nickname',
        'loignType',
        'isContinuous',
        'isSingleNormalMember',
        'isSingleDiamondMember',
        'isSingleMember',
        'isKeniuSuperNormalMember',
        'isKeniuSuperDiamondMember',
        'isKeniuSuperMember',
        'singleNormalMemberInfo',
        'singleDiamondMemberInfo',
        'keniuSuperNormalMemberInfo',
        'keniuSuperDiamondMemberInfo',
        'singleMemberInfo',
        'keniuSuperMemberInfo'
      ]

      viewModel.renewStatus = false
      viewModel.memberDateText = user.memberDateText()
      assignmentField.forEach((field) => (viewModel[field] = user[field]))
    })

    /** 是否为抠图会员中心 */
    const isKoutuMemberCenter = computed(() => route.name === 'KoutuMemberCenter')

    /** 头部描述定制文案 */
    const headText = computed(() => {
      if (!viewModel.isLogin) { // 未登录
        return '登录获取最新优惠信息!'
      }

      if (!viewModel.isVip) { // 非会员
        return '升级为会员，享会员特权服务'
      }

      if (viewModel.isKeniuSuperDiamondMember) { // 可牛超级钻石会员
        return '您已升级为超级钻石会员，终身享有所有会员权益'
      }

      if (viewModel.isKeniuSuperNormalMember) { // 可牛超级普通会员
        return '您已升级为超级会员，享可牛软件所有会员权益'
      }

      if (viewModel.isSingleMember) { // 单品会员(包含普通\钻石)
        return '升级为超级会员，享可牛软件所有会员权益'
      }

      return ''
    })

    /** 根据vip状态配置class, 这里为了兼容样式 */
    const heightClass = computed(() => {
      if (props.fixedHeight) {
        return 'hg_114'
      }
      // 会员无tab，非会员有tab （tab嵌在背景上，会员会有大量空白，这里用高度处理）
      return viewModel.isVip && !viewModel.renewStatus ? 'hg_114' : 'hg_154' // 超级会员版本
    })

    /** 登录类型class */
    const loginTypeClass = computed(() => {
      const loginTypeMap = {
        [login_type_info.wechat]: 'login_type_wechat',
        [login_type_info.qq]: 'login_type_qq',
        [login_type_info.phone]: 'login_type_phone'
      }

      return loginTypeMap[viewModel.loignType]
    })

    /** 点击续费按钮 */
    function clickRenew() {
      service.onRenew.next()
      tab.checkedSuperTab = true
      tab.onTabToggle.next('super')
      viewModel.renewStatus = true
    }

    /**
     * @description 处理会员日期文案
     */
    function memberInterestDateText (type: string) {
      const superTime = viewModel.keniuSuperMemberInfo?.expired_at
      const singleTime = viewModel.singleMemberInfo?.expired_at

      if (type === 'super' && viewModel.isKeniuSuperMember) {
        return viewModel.keniuSuperMemberInfo?.page_detail?.is_diamond ? '永久' : common.handleDate(Number(superTime))
      }

      if (type === 'single' && viewModel.isSingleMember) {
        return viewModel.singleMemberInfo?.page_detail?.is_diamond ? '永久' : common.handleDate(Number(singleTime))
      }

      return '未开通'
    }

    /** 查看权益 */
    function viewInterest () {
      const { origin, search } = location
      bridge.openOptionWindow({
        url: `${origin}/memberInterestDetail${search}`,
        open_web: 'memberInterestDetail',
        width: 675,
        height: 540
      })
    }

    /** 点击登录 */
    function clickLogin() {
      bridge.userLogin()
    }

    /** 错误使用默认头像 */
    function errorImg() {
      viewModel.avatar = require('@/assets/images/not-login-avatar.png')
    }

    /**
     * @description 打开用户详情
     */
    function openUserDetail () {
      if (!viewModel.isLogin) {
        return
      }

      controlModalVisible(true)
    }

    /**
     * @description 对话框关闭处理
     */
    function modalCancel () {
      controlModalVisible(false)
    }

    /**
     * @description 查看权益
     */
    function seeInterest () {
      window.open(config.getWebsiteUrl)
    }

    /**
     * @description 对话框成功处理
     */
    function modalSuccess () {
      controlModalVisible(false)
    }

    /**
     * @description 控制对话框显示隐藏
     */
    function controlModalVisible(visible: boolean) {
      viewModel.detailVisible = visible
    }

    return {
      headText,
      viewModel,
      heightClass,
      loginTypeClass,
      isKoutuMemberCenter,
      errorImg,
      clickRenew,
      clickLogin,
      modalCancel,
      seeInterest,
      modalSuccess,
      viewInterest,
      openUserDetail,
      memberInterestDateText
    }
  },
})
